import React from 'react';
import { Icon } from '../../common';

function SkipNextIcon(props) {
  return (
    <Icon width="19" height="22" viewBox="0 0 19 22" fill="none" {...props}>
      <path d="M10.5211 10.994L2.05714 16.5189V5.47973L10.5211 10.994Z" fill="black" stroke="black" strokeWidth="4.11429" />
      <path d="M16.1941 2.77148L16.1941 18.9653" stroke="black" strokeWidth="4.11429" strokeLinecap="round" />
    </Icon>
  );
}

export default React.memo(SkipNextIcon);
